import { queryOptions, useQuery } from '@tanstack/react-query';
import { SchemaFundingDto } from '../generated/apiTypes';
import { dataOrThrow, fetchClient } from '../lib/apiClient';
import { Gwei } from '../lib/gwei';

export const transformFundingRate = (rate: SchemaFundingDto) => ({
  timestamp: rate.createdAt,
  fundingRate1h: Gwei.toGwei(rate.fundingRate1h),
});

export type FundingRate = ReturnType<typeof transformFundingRate>;

export const fundingRateQuery = (productId: string, range: 'DAY' | 'WEEK' | 'MONTH') =>
  queryOptions({
    queryKey: ['GET', '/v1/funding', productId, range] as const,
    queryFn: async ({ queryKey, signal }) => {
      const [method, url, productId, range] = queryKey;
      const { data } = await fetchClient[method](url, {
        signal,
        params: { query: { productId, range, orderBy: 'createdAt', order: 'asc' } },
      }).then(dataOrThrow);

      return data?.data.map(transformFundingRate) ?? null;
    },
  });

export const useFundingRates = (productId: string, range: 'DAY' | 'WEEK' | 'MONTH') =>
  useQuery({ ...fundingRateQuery(productId, range), placeholderData: (oldData) => oldData });
